import { useRef, useState } from "react";
import { createCallSession } from "../../../utils/api/radar";
import CallSessionSheet from "../../CallSessionSheet";
import { errorCode, timer, track } from "../../../analytics";
import "./styles.css";
import card from "./card.module.css";

// "Your Kaptaan" row from "Tracking Result.dc.html". The tracking page draws the card around
// it (the Delivery OTP section sits under it in the same card). The call goes through a
// masked call session (create-session), never the rider's own number.
const RiderInfo = ({ imageUrl, name, tripId }) => {
  // null | { status: "loading" } | { status: "success", number } | { status: "error", error }
  const [session, setSession] = useState(null);
  const request = useRef(0); // a closed modal ignores a late response
  const firstName = name ? String(name).trim().split(/\s+/)[0] : "";

  const call = (step, extra) => track("tp_call_session", { step, via: "card", ...extra });
  const startSession = async (retry = false) => {
    if (session?.status === "loading") return;
    const id = ++request.current;
    if (!retry) track("tp_cta_click", { cta: "call_kaptaan", placement: "rider_card" });
    call("requested", { retry });
    setSession({ status: "loading" });
    if (!tripId) {
      call("failed", { error_class: "no_trip" });
      setSession({ status: "error", error: "Calling is available only while your order is out for delivery." });
      return;
    }
    const elapsed = timer();
    const res = await createCallSession(tripId);
    if (id !== request.current) return;
    if (res && res.message === "Success" && res.data) {
      call("created", { elapsed_ms: elapsed() });
      setSession({ status: "success", number: res.data });
    } else if (!res) {
      call("failed", { error_class: "network", elapsed_ms: elapsed() });
      setSession({ status: "error", error: "We couldn't reach the call service. Check your internet connection and try again." });
    } else {
      call("failed", { error_class: "service", code: errorCode(res), elapsed_ms: elapsed() });
      setSession({ status: "error" });
    }
  };

  if (!imageUrl) return null;
  return (
    <div className={card.row}>
      <span className={card.avatar}>
        <img src={imageUrl} alt={`${name ?? "Kaptaan"}`} width={52} height={52} />
      </span>
      <div className={card.text}>
        <span className={card.label}>Your Kaptaan</span>
        <span className={card.name}>{name ?? "NA"}</span>
      </div>
      <button type="button" className={card.call} title={`Call ${name ?? "Kaptaan"}`} aria-label={`Call ${name ?? "Kaptaan"}`} onClick={() => startSession(false)}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="#1F9D55" aria-hidden="true">
          <path d="M6.6 10.8a15.1 15.1 0 006.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1A17 17 0 013 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1z" />
        </svg>
      </button>
      {session && (
        <CallSessionSheet
          status={session.status}
          number={session.number}
          error={session.error}
          riderName={name}
          loadingText={`Creating a secure call line to ${firstName || "your Kaptaan"}…`}
          onClose={() => {
            request.current += 1;
            setSession(null);
          }}
          onRetry={() => startSession(true)}
          onCallNow={() => call("call_now")}
          onCopy={() => call("copy")}
        />
      )}
    </div>
  );
};

export default RiderInfo;
